<template>
  <div class=" mall">
    <div class="zz-page new-box-detail-page">
      <div class="page-content-new flex-box-div">
        <otherHeaderTop headerTitle="经典盲盒" :showBack="true" @back="back"></otherHeaderTop>
        <!-- 内容 -->
        <div class="box-detail-content" :style="{ paddingTop: safe_top + 'px' }">
          <div class="btm-tab">
            <div class="tab-inner1" id="tab-inner1" @mousedown="onMouseDown" @mousemove="onMouseMove"
              @mouseup="onMouseUp">
              <!-- <scroll-div class="tab-item-box" scroll-x="true" style="white-space:nowrap;" :show-scrollbar="true"> -->
              <div @click="
                handleChangeType(cate.boxTypeId, cate.boxTypeName, index)
                " v-for="(cate, index) in headerNav" :key="index" :index="index"
                :class="[currentId == cate.boxTypeId ? 'active' : '']" class="tab-item flex-center">
                <span class="name">{{ cate.boxTypeName }}</span>
              </div>
              <!-- </scroll-div> -->
            </div>
          </div>
          <!-- <div class="page-content-bg">
            <div class="bg-layer1" style="margin-top: 8.27 * 4.2px"></div>
            <div class="bg-layer2" style="margin-top: 8.27 * 4.2px"></div>
          </div> -->
          <div class="box-list-div">
            <div class="list-box" @scroll="scrollEventFn">
              <div class="box-wrap">
                <div class="box-item" :class="[item.selected ? 'active' : '']" @click="changeBox(item)"
                  v-for="(item, index) in boxDataList" :key="index">
                  <div class="img-item">
                    <img :src="`${$getFullPath(item.boxImg01)}`" mode="aspectFit" class="abs-full box-img" />
                    <img :src="`${$getFullPath(item.boxImg02)}`" mode="aspectFit" class="abs-full box-img2" />
                    <!-- <img
                      :src="item.boxImg02 | fullPath"
                      mode="aspectFit"
                      class="abs-full box-img"
                    /> -->
                  </div>
                  <div class="jinbi">
                    <img src="@/assets/home/jinbi.png" style="width: 10px; height: 10px" alt="">
                    <span>{{ item.price }}</span>
                  </div>
                  <!-- <div class="info-item">
                    <div class="info-price">
                      <img src="../../assets/images/balance2.png" class="coin" />
                      <span class="price">
                        <div class="digit-div digit-div">
                          <span v-for="(num, idx) in priceArray(item.price)" :key="idx" :class="num == '.' ? 'code_11 no-num' : 'code_' + num
                            " class="num-data offset_4" style="transform: scale(0.757576)"></span>
                        </div>
                      </span>
                    </div>
                  </div> -->
                  <div class="info-name text-ellipsis">{{ item.boxName }}</div>
                  <div class="box-select" v-if="item.selected"></div>
                  <div class="box-tag box-more">
                    <img src="../../assets/images/more.png" class="icon" />
                  </div>
                  <!-- <div class="box-sel" v-if="item.selected"></div> -->
                  <div class="box-tag" @click.stop="openDetail(item)"></div>
                </div>
              </div>
            </div>
            <!-- <span class="open-num">
              <span class="item" v-for="item in 5" :key="item" :class="isActive == item ? 'itemActive' : ''"
                @click="changeNum(item)">
                <span class="name">
                  {{ item }}
                </span>
              </span>
            </span> -->
            <!-- <div class="img-layer2"></div>
            <div class="team-detail"></div> -->
          </div>
        </div>
        <div class="btm-box">
          <!-- <div class="anim-layer2"></div> -->
          <!-- <div class="anim-layer1">
            <img class="box-one anim-box" src="../../assets/images/box-1.gif" />
            <img class="box-two anim-box" src="../../assets/images/box-2.gif" />
            <img class="box-three anim-box" src="../../assets/images/box-3.gif" />
            <img class="box-four anim-box" src="../../assets/images/box-4.gif" />
            <img class="box-five anim-box" src="../../assets/images/box-5.gif" />
          </div> -->
          <!-- <div class="img-layer1"></div> -->
          <div class="open-record" @click="openRecord">
            <!-- <div class="icon"></div> -->
          </div>
          <div class="open-btn" @click="openBox">
            <div class="price">
              <div class="digit-div digit-div price-num">
                {{ openPriceComputed }}开箱
                <!-- <span v-for="(num, index) in openPriceComputed" :index="index"
                  :class="[num == '.' ? 'code_11 no-num' : 'code_' + num]" class="num-data offset_-1"
                  style="transform: scale(1.09091)"></span> -->
              </div>
            </div>
            <!-- <div class="icon"></div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 盲盒详情 -->
    <modalBoxDetail :showModal="showDetail" :info="curBox" @close="showDetail = false"></modalBoxDetail>
    <!-- 全服记录 -->
    <modalBoxRecord :showModal="showRecord" @close="showRecord = false"></modalBoxRecord>
    <!-- 开箱 -->
    <modalUnopenBox :showModal="showOpen" :boxDetail="boxDetail" :boxId="curBoxId" :num="isActive"
      :openBoxData="openBoxData" @close="showOpen = false" @openResult="openResult"></modalUnopenBox>
    <modalBoxResult :showModal="showBoxResult" :num="isActive" :skinsInfo="skinsInfo" @close="showBoxResult = false">
    </modalBoxResult>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import modalBoxDetail from "@/components/common/modalBoxDetail.vue";
import modalBoxRecord from "@/components/common/modalBoxRecord.vue";
import modalUnopenBox from "@/components/common/modalUnopenBox.vue";
import modalBoxResult from "@/components/common/modalBoxResult.vue";
import { getArticle, getBoxList, getBoxTypeList, getDetail, openBox } from "@/api/index";
import store from "@/vuex/store";

export default {
  components: {
    otherHeaderTop,
    modalBoxDetail,
    modalBoxRecord,
    modalUnopenBox,
    modalBoxResult,
  },
  data() {
    return {
      istypeshow: false,
      boxTypeList: [],
      typePage: {
        page: 1,
        size: 10,
      },
      boxList: [],
      tableList: [],
      boxPage: {
        boxTypeId: "",
        boxTypeName: "盲盒类别",
        gameMouldId: 1,
        page: 1,
        size: 10,
        orderByFie: 2,
      },
      getAll: false,
      isOver: "加载中",
      scroll: "",
      headerNav: [],
      boxDataList: [],
      currentId: 0,
      // 新的
      player_skins_ids: "",
      name_2: "",
      isActive: 1,
      num: 1,
      showLogin: false,
      showRegister: false,
      safe_top: 0,
      showDetail: false,
      showRules: false,
      showRecords: false,
      showBalanceNo: false,
      showOpenBox: false,
      showBox: false,
      cates: [],
      curCateIndex: 0,
      curBoxId: 0,
      curRate: {},
      lists: [],
      page: 1,
      limit: 10,
      isOver: false,
      open_price: "0.00",
      curBox: {
        boxList: {
          skins_types: [],
          box_skins: [],
        },
      },
      user: {},
      boxList: [],
      lists: [],
      boxNav: [],
      tryData: {},
      isDragging: false,
      startX: 0,
      event: null,
      // 全服记录
      showRecord: false,
      // 开箱
      showOpen: false,
      boxDetail: [],
      skinsInfo: [],
      openBoxData: [],
      // skinsInfo: [
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      //   {
      //     id: 455366,
      //     userId: 79,
      //     boxId: 83,
      //     boxName: "哥特美女",
      //     boxPrice: 1.0,
      //     ornamentId: 1815394227,
      //     marketHashName: null,
      //     ornamentsZbtId: null,
      //     ornamentsYyId: null,
      //     ornamenName: null,
      //     ornamentsPrice: 0.03,
      //     exteriorName: "",
      //     shortName: "910 | Copenhagen 2024",
      //     usePrice: 0.03,
      //     imageUrl:
      //       "https://img.zbt.com/e/steam/item/730/U3RpY2tlciB8IDkxMCB8IENvcGVuaGFnZW4gMjAyNA==.png",
      //     ornamentsLevelId: 4,
      //     levelImg:
      //       "http://3.92.67.237:8080/profile/upload/2024/07/11/lan_20240711114224A003.png",
      //     status: 0,
      //     createTime: "2024-12-13 18:56:53",
      //     updateTime: "2024-12-13 18:56:53",
      //     source: 1,
      //     fightId: null,
      //     fightRoundNumber: null,
      //     rollId: null,
      //     holderUserId: 79,
      //     isShow: null,
      //   },
      // ],
      // 开箱结果盒子
      showBoxResult: false,
    };
  },
  mounted() {
    //this.getTypeList();
    this.getList();
  },
  on() { },
  activated() {
    this.$soundStop("indexBgm");
    this.$soundPlay("boxBgm", true);
    let box = document.getElementsByClassName("box");
    console.log(box);
    if (this.scroll > 0) {
      box[0].scrollTo(0, this.scroll);
      this.scroll = 0;
    }
  },
  methods: {
    changeBox(item) {
      this.$soundPlay("boxSelect");
      this.boxDataList.forEach((itm) => {
        itm.selected = false;
      });
      this.boxDataList.sort((a, b) => a.price - b.price);
      item.selected = true;
      this.open_price = item.price;
      this.curBoxId = item.boxId;
      this.$forceUpdate();
    },
    openDetail(item) {
      this.$soundPlay("click");
      this.showDetail = true;
      this.curBox = item;
    },
    onMouseDown() { },
    onMouseMove() { },
    onMouseUp() { },
    changeCate() { },
    changeNum(value) {
      console.log(value, "value");
      this.isActive = value;
      this.$soundPlay("boxSwitch");
    },
    showRule() { },
    openRecord() {
      this.showRecord = true;
    },
    goToRegister() { },
    openBox() {
      if (this.curBoxId == 0) {
        this.$message({
          duration: 1000,
          message: "请选择盲盒",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      // 判断是否已经登录
      if (this.$store.state.LOGIN_IS_SHOW) {
        this.$message({
          duration: 1000,
          message: "请先登录",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      getDetail(this.curBoxId).then((res) => {
        if (res.data.code == 200) {
          this.boxDetail = res.data.data.boxOrnamentsList;
          openBox({ boxId: this.curBoxId, num: this.isActive }).then((res) => {
            if (res.data.code == 200) {
              this.openBoxData = res.data.data;
              this.showOpen = true;
            }
          })
        } else {
          this.$message({
            duration: 1000,
            message: res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
    },
    // 旧的
    // 接收开箱结果的数据
    openResult(skinsInfo) {
      this.skinsInfo = skinsInfo;
      this.showBoxResult = true; // 显示开箱结果
    },
    priceArray(price) {
      // console.log(String(price).split(''),'ceshi');
      // 将数字或字符串形式的价格转换为字符数组
      return String(price).split("");
    },
    // 返回上一页
    back() {
      this.$router.go(-1);
      // this.$soundStop("indexBgm");
      this.$soundStop("boxBgm");
    },
    handleChangeType(res, name, index) {
      this.boxDataList = this.boxList[index].boxList;
      this.boxDataList.forEach((itm) => {
        itm.selected = false;
      });
      this.boxDataList.sort((a, b) => a.price - b.price);
      this.boxDataList[0]['selected'] = true;
      this.currentId = res;
      this.open_price = this.boxDataList[0].price;
      this.curBoxId = this.boxDataList[0].boxId;
    },
    handleScroll(e) {
      this.event = e;
      this.scroll = e.srcElement.scrollTop;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        if (this.isOver == "加载中") {
          this.boxPage.page++;
          setTimeout(() => {
            this.getList();
          }, 5);
        }
      }
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    handleilltate() {
      this.$bus.$emit("is_illustrate", true);
      setTimeout(() => {
        getArticle("wzmh").then((res) => {
          let dream = res.data.data.contentList[0].content;
          this.$bus.$emit("nr_illustrate", dream);
        });
      }, 500);
    },
    handleGo(res) {
      this.$router.push({
        path: "/openbox",
        query: {
          id: res,
        },
      });
    },
    getTypeList() {
      if (this.boxTypeList.length == 0) {
        getBoxTypeList(this.typePage).then((res) => {
          if (res.data.code == 200) {
            console.log(res.data, "woyao de shuju");
            this.boxTypeList.push(...res.data.data.records);
            if (res.data.data.records.length == this.typePage.size) {
              this.typePage.page++;
              this.getTypeList();
            } else {
              this.getAll = true;
            }
          }
          console.log("玩法列表", this.boxTypeList);
        });
      }
    },
    getList() {
      let data = {
        boxType: 1,
      };
      getBoxList(data).then((res) => {
        if (res.data.code == 200) {
          this.headerNav = res.data.data;
          this.currentId = this.headerNav[0].boxTypeId;
          this.boxList = res.data.data;
          this.boxDataList = res.data.data[0].boxList.sort(
            (a, b) => a.price - b.price
          );
          this.boxDataList.forEach((itm) => {
            itm.selected = false;
          });
          this.boxDataList[0]['selected'] = true;
          this.open_price = this.boxDataList[0].price;
          this.curBoxId = this.boxDataList[0].boxId;
          if (res.data.data.length < this.boxPage.size) {
            this.isOver = "暂无更多";
          }
        }
      });
      // getBoxList(this.boxPage).then((res) => {
      //   // console.log("箱子列表", res.data.data);
      //   if (res.data.code == 200) {
      //     let arr = res.data.data;
      //     arr.forEach((item) => {
      //       if (this.boxList.get(item.boxTypeId)) {
      //         this.boxList.get(item.boxTypeId).push(item);
      //       } else {
      //         this.boxList.set(item.boxTypeId, [item]);
      //       }
      //     });
      //     console.log("箱子列表map", this.boxList);
      //     if (res.data.data.length < this.boxPage.size) {
      //       this.isOver = "暂无更多";
      //     }
      //     this.boxTypeList.map((item) => {
      //       return (item.children = this.boxList.get(item.id));
      //     });
      //     this.tableList = this.boxTypeList.filter((item) => {
      //       return item.children;
      //     });
      //     console.log("处理后的分类", this.tableList);
      //   }
      // });
    },
    scrollEventFn(e) {
      // 触底加载
      // this.event = e;
      // if (
      //   e.srcElement.scrollTop + e.srcElement.clientHeight >=
      //   e.srcElement.scrollHeight
      // ) {
      //   if (this.queryParams.pageSize == this.total) {
      //     this.queryParams.pageSize += 15;
      //     setTimeout(() => {
      //       this.getShopList();
      //     }, 5);
      //   } else {
      //     this.isOver = "暂无更多";
      //   }
      // }
    },
  },
  watch: {
    getAll(newValue) {
      if (newValue) {
        this.getList();
      }
    },
  },
  computed: {
    // 计算属性
    openPriceComputed() {
      return (this.open_price * this.isActive).toFixed(2).toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.boxes {
  --head-height: 20 * 4.2px;
  height: 100%;
}

.new-box-detail-page {
  position: relative;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.new-box-detail-page .mask-ts {
  z-index: 10000;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: solid 0.67 * 4.2px red;
}

.new-box-detail-page .mask-ts .box1 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background: #1b7cc9;
}

.new-box-detail-page .mask-ts .box2 {
  height: 40 * 4.2px;
  background: #00a2ff;
}

.new-box-detail-page .content-layer {
  padding-bottom: 50.67 * 4.2px;
}

.new-box-detail-page .btm-box {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 20 * 4.2px;
  background: rgba(15, 2, 97, 0.6);
  border-radius: 8px 8px 8px 8px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4.76 * 4.2px;
}

.new-box-detail-page .btm-box .anim-layer2 {
  position: absolute;
  top: -12.67 * 4.2px;
  left: 0;
  right: 0;
  height: 59.73 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_bg_6.png");
}

.new-box-detail-page .btm-box .anim-layer1 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 46.8 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_bg_5.png");
}

.new-box-detail-page .btm-box .anim-layer1 .anim-box {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.new-box-detail-page .btm-box .anim-layer1 .box-all,
.new-box-detail-page .btm-box .anim-layer1 .box-one {
  top: 0;
  left: 0;
}

.new-box-detail-page .btm-box .img-layer1 {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 14.53 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/app_ft_2.png");
}

.new-box-detail-page .btm-box .open-record {
  // position: absolute;
  // top: 28.13 * 4.2px;
  // left: 0;
  width: 10 * 4.2px;
  height: 12.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/image3/home/information.png");
}

.new-box-detail-page .btm-box .open-record .icon {
  width: 3.73 * 4.2px;
  height: 4.67 * 4.2px;
  margin: 1.73 * 4.2px 0 0 6.27 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/list-icon.png");
}

.new-box-detail-page .btm-box .open-btn {
  // position: absolute;
  // top: 25.6 * 4.2px;
  // left: 28.67 * 4.2px;
  width: 40.48 * 4.2px;
  height: 10.48 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-size: 100% 100%;
  background-image: url("../../assets/image3/home/unpackingBack.png");
  z-index: 2;
  align-items: center;
}

.new-box-detail-page .btm-box .open-btn .price {
  // display: inline-block;
  // height: 4.53 * 4.2px;
  // margin: 4.4 * 4.2px 0 0 2.67 * 4.2px;
}

.new-box-detail-page .btm-box .open-btn .price .price-num {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 3.81 * 4.2px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;

  @media only screen and (max-width: 430px) {
    font-size: 3.81vw;
  }
}

.new-box-detail-page .btm-box .open-btn .icon {
  display: inline-block;
  width: 14.27 * 4.2px;
  height: 8.13 * 4.2px;
  margin: 1.6 * 4.2px 0 0 0;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_ic_2.png");
}

.new-box-detail-page .btm-box .open-setting {
  position: absolute;
  top: 28.13 * 4.2px;
  right: 0;
  width: 14 * 4.2px;
  height: 8.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_bg_2.png");
}

.new-box-detail-page .btm-box .open-setting .icon {
  float: right;
  width: 4.53 * 4.2px;
  height: 4.53 * 4.2px;
  margin: 1.73 * 4.2px 6.13 * 4.2px 0 0;
  background-size: 100% 100%;
  background-image: url("../../assets/images/system-icon.png");
}

.new-box-detail-page .box-detail-content {
  position: relative;
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.new-box-detail-page .box-detail-content .rule-icon {
  position: absolute;
  top: 0.87 * 4.2px;
  right: 2.67 * 4.2px;
  width: 4.53 * 4.2px;
  height: 4.53 * 4.2px;
  z-index: 100;
}

.new-box-detail-page .box-detail-content .load-more-btn {
  width: 22.93 * 4.2px;
  height: 7.6 * 4.2px;
  -webkit-border-radius: 0.8 * 4.2px;
  border-radius: 0.8 * 4.2px;
  text-align: center;
  line-height: 7.6 * 4.2px;
  margin: 2.67 * 4.2px auto 6.67 * 4.2px auto;
  background: #303a4e;
  font-size: 3.73 * 4.2px;
  color: #c9d5e5;
}

.new-box-detail-page .box-detail-content .load-more-btn:active {
  opacity: 0.75;
}

.new-box-detail-page .box-detail-title-img {
  width: 23.87 * 4.2px;
  height: 6 * 4.2px;
}

.page-content-bg {
  position: absolute;
  top: 72.8px;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  z-index: 0;
}

.page-content-bg .bg-layer1 {
  position: absolute;
  top: 8.8 * 4.2px;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/page_ct_bk2.png") repeat-y top center / 100% auto;
}

.page-content-bg .bg-layer1-frag {
  background: url("../../assets/images/page_ct_bk3.png") repeat-y top center / 100% auto;
}

// .page-content-bg .bg-layer2 {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: url("../../assets/images/page_ct_bk1.png") no-repeat top center / 100% 8.8 * 4.2px;
// }

.box-list-div {
  position: absolute;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-top: 55px;
}

.box-list-div .goods-probability {
  height: 9.33 * 4.2px;
  margin: 4 * 4.2px 0 4.27 * 4.2px;
}

.box-list-div .list-box {
  height: calc(100vh - 365px);
  overflow-y: auto;
  @media only screen and (max-width: 430px) {
    height: 70vh;
  }
}

.box-list-div .box-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 2.67 * 4.2px 0 0 2.8 * 4.2px;
}

.box-list-div .box-wrap .box-item {
  position: relative;
  width: 28.67 * 4.2px;
  height: 33 * 4.2px;
  color: #E5C7FF;
  margin: 0 1.33 * 4.2px 2.67 * 4.2px;
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/box_bg_10.png");
  background: linear-gradient(180deg, #5B1CE3 0%, #320F7D 100%);
  box-shadow: inset 0px 0px 6px 0px #6BA0CD;
  border-radius: 2px 2px 2px 2px;
  border: 0px solid #B378E0;
  font-size: 2.31 * 4.2px;
}

.box-list-div .box-wrap .box-item.active {
  background: linear-gradient(180deg, #6F1CE3 0%, #E226FF 100%);
  box-shadow: inset 0px 0px 6px 0px #6BA0CD;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid;
  border-image: linear-gradient(180deg, rgba(224, 255, 255, 1), rgba(224, 255, 255, 0), rgba(224, 255, 255, 1)) 1 1;
}

.box-list-div .box-wrap .box-item .jinbi {
  position: absolute;
  top: 1.19 * 4.2px;
  left: 1.19 * 4.2px;
  display: flex;
  align-items: center;
  font-size: 2.86 * 4.2px;

  span {
    margin-left: 4px;
  }

  @media only screen and (max-width: 430px) {
    top: 1.19vw;
    left: 1.19vw;
    font-size: 2.86vw;
  }
}

.box-list-div .box-wrap .box-item .box-sel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 26.67 * 4.2px 26.93 * 4.2px;
  background-image: url("../../assets/images/box_sel.png");
}

.box-list-div .box-wrap .box-item .img-item {
  position: relative;
  height: 18.67 * 4.2px;
  margin-top: 6.5 * 4.2px;
}

.box-list-div .box-wrap .box-item .img-item .box-img {
  -o-object-fit: scale-down;
  object-fit: scale-down;
}
.box-list-div .box-wrap .box-item .img-item .box-img2 {
  width: 60%;
  height: 60%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.box-list-div .box-wrap .box-item .info-item {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 13.73 * 4.2px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 26.67 * 4.2px 12.27 * 4.2px;
  background-image: url("../../assets/images/box_bg_11.png");
}

.box-list-div .box-wrap .box-item .info-item .info-price {
  width: 100%;
  height: 7.47 * 4.2px;
  margin: 6 * 4.2px 0 0 0.67 * 4.2px;
}

.box-list-div .box-wrap .box-item .info-item .info-price .coin {
  float: left;
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
  margin: 0.93 * 4.2px 2.67 * 4.2px 0 2.53 * 4.2px;
}

.box-list-div .box-wrap .box-item .info-item .info-price .price {
  float: left;
  width: 17.33 * 4.2px;
  margin: 1.33 * 4.2px 0 0 -4 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.box-list-div .box-wrap .box-item .info-name {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  height: 4.13 * 4.2px;
  line-height: 4.13 * 4.2px;
  font-size: 3.33 * 4.2px;
  // font-weight: 700;
  text-align: left;
  color: #fff;
  padding: 0 0.67 * 4.2px;
  margin-left: 1.19 * 4.2px;
}

.box-list-div .box-wrap .box-item .box-select {
  width: 7.14 * 4.2px;
  height: 7.14 * 4.2px;
  background-image: url("../../assets/image3/home/selectShop.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
}

.box-list-div .box-wrap .box-item .box-tag {
  z-index: 1;
  position: absolute;
  top: 1.47 * 4.2px;
  right: 1.6 * 4.2px;
  width: 5.47 * 4.2px;
  height: 4.13 * 4.2px;
}

.box-list-div .box-wrap .box-item .box-more {
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/k18.png");
}

.box-list-div .box-wrap .box-item .box-more .icon {
  float: left;
  width: 2.67 * 4.2px;
  height: 2.67 * 4.2px;
  margin: 0.67 * 4.2px 0 0 1.87 * 4.2px;
}

.btm-tab {
  z-index: 100;
  position: absolute;
  // bottom: 30.67*4.2px;
  // top: 15 * 4.2px;
  left: 0;
  width: 100%;
  height: 16 * 4.2px;
  // overflow-x: scroll;
  // overflow-y: hidden;
}

.btm-tab .tab-inner {
  position: absolute;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
}

.tab-inner1 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  // -webkit-justify-content: center;
  -ms-flex-pack: center;
  // justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 100%;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-left: 3.57 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 3.57vw;
  }

  // overflow-x: scroll;
  // overflow-y: hidden;
}

.btm-tab .tab-item {
  float: left;
  width: 23 * 4.2px;
  height: 9 * 4.2px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  background-image: url("../../assets/image3/share/notSelectedBack.png");
  flex-shrink: 0;
}

.btm-tab .tab-item .name {
  height: 9.33 * 4.2px;
  line-height: 9.33 * 4.2px;
  text-align: center;
  color: #8799d8;
  font-size: 3.33 * 4.2px;
  overflow: hidden;
}

.btm-tab .tab-item.active {
  width: 23 * 4.2px;
  height: 9 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/image3/share/selectBack.png");

  @media only screen and (max-width: 430px) {
    width: 23vw;
    height: 9vw;
  }
}

.btm-tab .tab-item.active .name {
  color: #fff;
}

// .box-list-div .img-layer2 {
//   z-index: 16;
//   position: absolute;
//   bottom: 300.386px;
//   left: 0;
//   right: 0;
//   height: 5.47 * 4.2px;
//   background-size: 100% 100%;
//   background-image: url("../../assets/images/box_bg_7.png");
// }

.type-level {
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  // height: 12*4.2px;
  // line-height: 12*4.2px;
  color: #fff;
  font-size: 3.2 * 4.2px;
}

.type-level .pre-color {
  width: 2.67 * 4.2px;
  height: 2.67 * 4.2px;
  margin-right: 0.67 * 4.2px;
  background-size: 100% 100%;
}

.type-level .pre-color.color1 {
  background-color: #a37e2e;
}

.type-level .pre-color.color2 {
  background-color: #a32a5c;
}

.type-level .pre-color.color3 {
  background-color: #7c2ba7;
}

.type-level .pre-color.color4 {
  background-color: #2b4ea7;
}

.type-level .level {
  min-width: 16 * 4.2px;
  padding-left: 4 * 4.2px;
}

.type-level .level3 {
  padding-right: 1.33 * 4.2px;
}

.type-level .level2 {
  padding-right: 1.33 * 4.2px;
}

.type-level .level1 {
  padding-right: 1.33 * 4.2px;
}

.type-level text {
  display: inline-block;
}

.open-num {
  width: 100 * 4.2px;
  height: auto;
  position: absolute;
  left: 0;
  bottom: 221.214px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  z-index: 2;

  .item {
    width: 18.93 * 4.2px;
    height: 15.2 * 4.2px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 13.33 * 4.2px 13.33 * 4.2px;
    background-image: url("../../assets/images/k19.png");
    margin: 0 0.6 * 4.2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }

  .name {
    display: inline-block;
    width: 8 * 4.2px;
    height: 9.33 * 4.2px;
    line-height: 9.33 * 4.2px;
    text-align: center;
    color: #8799d8;
    font-size: 5.73 * 4.2px;
  }

  .itemActive {
    background-size: 100% 100%;
    background-image: url("../../assets/images/box_bg_8.png");
  }
}

.btm-tab .tab-item-box {
  display: flex;
  flex-wrap: nowrap;
}

.box-list-div .box-wrap .box-item .info-item .info-price .price .digit-div .num-data {
  scale: 1.2;
}

.look-skins {
  width: 60%;
  // height: 21px;
  border-radius: 99 * 4.2px;
  border: 0.2 * 4.2px solid #e1e9ea;
  padding: 1 * 4.2px 0;
  // border-image: radial-gradient(
  //     circle,
  //     rgba(250, 250, 250, 1),
  //     rgba(225, 233, 234, 1),
  //     rgba(194, 194, 194, 1),
  //     rgba(158, 158, 158, 1)
  //   )
  //   1 1;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10 * 4.2px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;

  .btn {
    font-size: 3 * 4.2px;
    text-align: center;
    color: transparent;
    -webkit-background-clip: text;
    background-image: linear-gradient(85.05388423353507deg,
        #fafafa 0%,
        #e1e9ea 21%,
        #c2c2c2 76%,
        #9e9e9e 100%);

    img {
      width: 3 * 4.2px;
      height: 3 * 4.2px;
      margin-right: 1 * 4.2px;
    }
  }
}

@media only screen and (max-width: 430px) {
  .boxes {
    --head-height: 20vw;
  }

  .new-box-detail-page .mask-ts {
    border: solid 0.67vw red;
  }

  .new-box-detail-page .mask-ts .box2 {
    height: 40vw;
  }

  .new-box-detail-page .content-layer {
    padding-bottom: 50.67vw;
  }

  .new-box-detail-page .btm-box {
    height: 20vw;
    position: fixed;
    bottom: 0;
    padding: 0 4.76vw;
  }

  .new-box-detail-page .btm-box .anim-layer2 {
    top: -12.67vw;

    height: 59.73vw;
  }

  .new-box-detail-page .btm-box .anim-layer1 {
    height: 46.8vw;
  }

  .new-box-detail-page .btm-box .img-layer1 {
    height: 14.53vw;
  }

  .new-box-detail-page .btm-box .open-record {
    // top: 28.13vw;
    // left: 0;
    width: 10vw;
    height: 12.4vw;
  }

  .new-box-detail-page .btm-box .open-record .icon {
    width: 3.73vw;
    height: 4.67vw;
    margin: 1.73vw 0 0 6.27vw;
  }

  .new-box-detail-page .btm-box .open-btn {
    // top: 25.6vw;
    // left: 28.67vw;
    width: 40.48vw;
    height: 10.48vw;
  }

  .new-box-detail-page .btm-box .open-btn .price {
    // height: 4.53vw;
    // margin: 4.4vw 0 0 2.67vw;
  }

  .new-box-detail-page .btm-box .open-btn .icon {
    display: inline-block;
    width: 14.27vw;
    height: 8.13vw;
    margin: 1.6vw 0 0 0;
  }

  .new-box-detail-page .btm-box .open-setting {
    top: 28.13vw;

    width: 14vw;
    height: 8.4vw;
  }

  .new-box-detail-page .btm-box .open-setting .icon {
    width: 4.53vw;
    height: 4.53vw;
    margin: 1.73vw 6.13vw 0 0;
  }

  .new-box-detail-page .box-detail-content .rule-icon {
    top: 0.87vw;
    right: 2.67vw;
    width: 4.53vw;
    height: 4.53vw;
  }

  .new-box-detail-page .box-detail-content .load-more-btn {
    width: 22.93vw;
    height: 7.6vw;
    -webkit-border-radius: 0.8vw;
    border-radius: 0.8vw;

    line-height: 7.6vw;
    margin: 2.67vw auto 6.67vw auto;

    font-size: 3.73vw;
  }

  .new-box-detail-page .box-detail-content .load-more-btn:active {
    opacity: 0.75;
  }

  .new-box-detail-page .box-detail-title-img {
    width: 23.87vw;
    height: 6vw;
  }

  .page-content-bg .bg-layer1 {
    top: 8.8vw;
  }

  // .page-content-bg .bg-layer2 {
  //   background: url("../../assets/images/page_ct_bk1.png") no-repeat top center / 100% 8.8vw;
  // }

  .box-list-div .goods-probability {
    height: 9.33vw;
    margin: 4vw 0 4.27vw;
  }

  .box-list-div .box-wrap {
    margin: 2.67vw 0 0 2.8vw;
  }

  .box-list-div .box-wrap .box-item {
    width: 28.67vw;
    height: 33vw;
    margin: 0 1.33vw 2.67vw;
  }

  .box-list-div .box-wrap .box-item .box-sel {
    background-size: 26.67vw 26.93vw;
  }

  .box-list-div .box-wrap .box-item .img-item {
    position: relative;
    height: 18.67vw;
    margin-top: 6.5vw;
  }

  .box-list-div .box-wrap .box-item .info-item {
    height: 13.73vw;

    background-size: 26.67vw 12.27vw;
  }

  .box-list-div .box-wrap .box-item .info-item .info-price {
    width: 100%;
    height: 7.47vw;
    margin: 6vw 0 0 0.67vw;
  }

  .box-list-div .box-wrap .box-item .info-item .info-price .coin {
    width: 3.87vw;
    height: 3.6vw;
    margin: 0.93vw 2.67vw 0 2.53vw;
  }

  .box-list-div .box-wrap .box-item .info-item .info-price .price {
    width: 17.33vw;
    margin: 1.33vw 0 0 -4vw;
  }

  .box-list-div .box-wrap .box-item .info-name {
    height: 4.13vw;
    line-height: 4.13vw;
    font-size: 3.33vw;
    padding: 0 0.67vw;
    margin-left: 1.19vw;
  }

  .box-list-div .box-wrap .box-item .box-tag {
    z-index: 1;
    position: absolute;
    top: 1.47vw;
    right: 1.6vw;
    width: 5.47vw;
    height: 4.13vw;
  }

  .box-list-div .box-wrap .box-item .box-more .icon {
    width: 2.67vw;
    height: 2.67vw;
    margin: 0.67vw 0 0 1.87vw;
  }

  .btm-tab {
    left: 0;
    width: 100%;
    height: 16vw;
  }

  .btm-tab .tab-item {
    float: left;
    width: 23vw;
    height: 9vw;
  }

  .btm-tab .tab-item .name {
    height: 9.33vw;
    line-height: 9.33vw;
    font-size: 3.33vw;
  }

  // .box-list-div .img-layer2 {
  //   height: 5.47vw;
  // }

  .type-level {
    height: 8vw;
    line-height: 8vw;

    color: #fff;
    font-size: 3.2vw;
  }

  .type-level .pre-color {
    width: 2.67vw;
    height: 2.67vw;
    margin-right: 0.67vw;
  }

  .type-level .level {
    min-width: 16vw;
    padding-left: 4vw;
  }

  .type-level .level3 {
    padding-right: 1.33vw;
  }

  .type-level .level2 {
    padding-right: 1.33vw;
  }

  .type-level .level1 {
    padding-right: 1.33vw;
  }

  .open-num {
    width: 100vw;
    height: auto;
    position: fixed;
    left: 0;
    bottom: 27.67vw;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    .item {
      width: 18.93vw;
      height: 15.2vw;

      margin: 0 0.6vw;
    }

    .name {
      width: 8vw;
      height: 9.33vw;
      line-height: 9.33vw;

      font-size: 5.73vw;
    }
  }

  .look-skins {
    border-radius: 99vw;
    border: 0.2vw solid #e1e9ea;
    padding: 1vw 0;

    border-radius: 10vw;

    .btn {
      font-size: 3vw;

      img {
        width: 3vw;
        height: 3vw;
        margin-right: 1vw;
      }
    }
  }
}
</style>
